import {createReducer} from "@reduxjs/toolkit";
import {mddifyChartType} from "../actions/ChartTypeAction";

export const chartTypeReducer = createReducer(
    ''
    ,
    (builder) => {
        builder.addCase(mddifyChartType, (state, action) => {
            return action.payload;
        });
    }
);
